module.exports = __webpack_public_path__ + "img/reportDefault.6a175206.png";